<script setup>
  import { computed } from 'vue';
  import SpotHeaderSubhead from '@/components/SpotHeaderSubhead.vue';

  const props = defineProps({
    spot: {
      type: Object,
      required: true
    },
    isNowcastingSpot: {
      type: Boolean,
      default: false
    },
    // Text shown under the spot name. When no string is passed, the spot's location is shown.
    subhead: {
      type: String,
      default: null
    }
  })

  const spotName = computed(() => props.isNowcastingSpot ? `${props.spot.name} <span class="jwx-page__title-tag">Nowcast</span>` : props.spot.name);

  const spotLocation = computed(() => {
    const locationParts = [];
    if (props.spot?.city) locationParts.push(props.spot.city);
    if (props.spot?.county) locationParts.push(props.spot.county);
    if (props.spot?.state) locationParts.push(props.spot.state);
    if (props.spot?.country) locationParts.push(props.spot.country);

    return locationParts.join(", ")
  });

  const usesLocation = computed(() => typeof props.subhead !== 'string');
  const subheadText = computed(() => usesLocation.value ? spotLocation.value : props.subhead);
  const subheadIcon = computed(() => usesLocation.value ? 'location-marker' : null);
  const hasSubhead = computed(() => subheadText.value === '' ? null : true);
</script>

<template>
  <div class="jwx-toolbar-header__title" :data-has-location="hasSubhead">
    <h1 v-html="spotName" class="jwx-toolbar-header__title-text"></h1>
    <SpotHeaderSubhead
      v-if="hasSubhead"
      :text="subheadText"
      :icon="subheadIcon"
    />
  </div>
</template>
